$(document).on('click', '.product-quick-add-swatch .swatch-element', function(e){
  e.preventDefault();
  e.stopPropagation();
  var image = $(this).data('image');
  var value = $(this).data('value');
  var variant = $(this).data('variant');
  var $container = $(this).parents('.product-quick-add-container');
  $container.find('.js-swatch-current-selection').text(value);
  $container.find('#product-quick-add-image').attr('src', image);
  $container.find('.product-quick-add-popup-atc.js-product-quick-add').data('id', variant);
})

$(document).on("click", ".js-open-qa", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var $qv = $(".product-quick-add-popup");
  var handle = $(this).data("handle");
  var variant = $(this).data('variant');
  var url = "/products/" + handle + "?view=quick-add"; 
  

  if(variant){
    url += "&variant=" + variant;
  }
  
  $.ajax({
    type: "GET",
    url: url,
    success: function (html) {
    
      
      $qv.find(".product-quick-add-popup-content").html(html);
      $("html, body").addClass("qa--open");
      window.addEventListener("click",handleClickOutsideQA);
      $qv.addClass("open");
    },
    error: function () {
      window.location.href = $(this).attr("href");
    },
  });
});

$(document).on('click', '.js-product-quick-add-popup-close', function(e){
  quickAddPopupClose();
})

$(document).on('click', '.js-product-quick-add', function(e){
  var $this = $(this);
  $this.prop('disabled', true);
  setTimeout(function(){
    quickAddPopupClose();
    $this.prop('disabled', false);
    window.removeEventListener("click",handleClickOutsideQA);
  }, 2000);
})

function quickAddPopupClose(){
  $("html, body").removeClass("qa--open");
  var $qv = $(".product-quick-add-popup");
  $qv.removeClass('open');
}

function handleClickOutsideQA(e){
  if (
    !$(e.target).is(".product-quick-add-popup-content-wrapper *") &&
    $("html").hasClass("qa--open")
  ) {
    quickAddPopupClose();
  }
}